
export const nonRouteScreenNames = {
  nonKraConsentSelection: "aop_non_kra_consent_selection",
};

const routeScreenNameMap: Array<[string, string]> = [
  ["/status/already-exists", "aop_existing_account_found"],
  ["/status/not-found", "aop_lead_not_found"],
  ["/status/doc-verification-in-progress", "aop_verify_pending_docs"],
  ["/status/continue", "aop_form_incomplete"],
  ["/status", "aop_know_your_status"],
  ["/new-lading", "aop_select_account"],
  ["/otp", "aop_authentication"],
  ["/pan", "aop_pan_verification"],
  ["/partner", "aop_basic_details"],
  ["/op", "aop_basic_details"],
  // must stay above "/profile", otherwise "/profiler" is swallowed by the
  // startsWith match and reports as aop_primary_details
  ["/profiler", "aop_additional_profile_information"],
  ["/profile", "aop_primary_details"],
  ["/bank", "aop_bank_details"],
  ["/plan", "aop_segment_details"],
  ["/selfie", "aop_selfie_doc_upload"],
  ["/authenticate", "aop_kra_e_sign"],
  ["/esignsubmit", "aop_stage_completion"],
  ["/kycsubmit", "aop_account_opening_submitted"],
  ["/ocv", "aop_account_opening_submitted"],
  ["/esign", "aop_e_sign"],
  ["/verify_personal_documents", "aop_normal_doc_verification"],
  ["/verify", "aop_e_sign"],
  ["/submit", "aop_account_opening_submitted"],
  ["/continue", "aop_resume_journey"],
  ["/ipvLink", "aop_video_verification"],
  ["/ipv", "aop_video_verification"],
  ["/accexists", "aop_existing_account_found"],
  ["/demat", "aop_link_demat"],
  ["/personalInformation", "aop_normal_doc_verification"],
  ["/dgLocker", "aop_digilocker_doc_verification"],
  ["/showDocuments", "aop_digilocker_doc_verification"],
  ["/", "aop_basic_details"],
];


export function getScreenName(pathname: string): string | undefined {
  try {
    const match = routeScreenNameMap.find(([path]) =>
      path === "/" ? pathname === "/" : pathname.startsWith(path)
    );
    return match?.[1];
  } catch (e) {
    console.error("getScreenName failed", e);
    return undefined;
  }
}
